import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-tnq',
  templateUrl: './tnq.component.html',
  styleUrls: ['./tnq.component.scss']
})
export class TNQComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public loadScript: LoadScriptService
  ) {
    
  }

  ngOnInit(): void {
    this.titleService.setTitle('世界最大級の出版社に技術提供するTNQがTrinkaを言語品質評価に活用');
    this.metaTagService.updateTag({ name: 'description', content: "エンドツーエンドのサービスや製品を提供するプロバイダーであるTNQとAI英文校正Trinkaを開発したエナゴは共同で、国際的な学術大手出版社に、AIを搭載したソリューション「Language Central」を提供しました。" });
    this.metaTagService.updateTag({ property: 'og:title', content: '世界最大級の出版社に技術提供するTNQがTrinkaを言語品質評価に活用' });
    this.metaTagService.updateTag({ property: 'og:description', content: '​エンドツーエンドのサービスや製品を提供するプロバイダーであるTNQとAI英文校正Trinkaを開発したエナゴは共同で、国際的な学術大手出版社に、AIを搭載したソリューション「Language Central」を提供しました。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/case-study/tnq' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '世界最大級の出版社に技術提供するTNQがTrinkaを言語品質評価に活用' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "エンドツーエンドのサービスや製品を提供するプロバイダーであるTNQとAI英文校正Trinkaを開発したエナゴは共同で、国際的な学術大手出版社に、AIを搭載したソリューション「Language Central」を提供しました。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/case-study/tnq' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/case-study/tnq' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/case-study/tnq' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/case-study/tnq' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/case-study/tnq' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/case-study/tnq' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/case-study/tnq' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/case-study/tnq' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/case-study/tnq' });
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

}
